import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

const AboutUs = () => {
  return (
    <div>
      <Helmet>
        <title>
          About Us | Orient Elevators Pvt. Ltd. | Leading Elevator & Lift
          Manufacturer in India
        </title>

        <meta
          name="keywords"
          content="Orient Elevators, elevator company India, lift manufacturer, elevator installation, elevator maintenance, home lifts, commercial elevators, passenger lifts, elevator solutions"
        />

        <meta
          name="description"
          content="Learn about Orient Elevators Pvt. Ltd., a leading elevator and lift manufacturer in India. Discover our journey, values, expertise, and commitment to providing safe, reliable, and innovative vertical transportation solutions."
        />
      </Helmet>

      <section
        className="page-title centred"
        style={{
          backgroundImage: "url('assets/img/slider/slider-2.jpg')",
        }}
      >
        <div className="auto-container">
          <div className="content-box">
            <div className="title">
              <h1>About Us</h1>
            </div>
            <ul className="bread-crumb clearfix">
              <li>
                <Link to="/"> Home</Link>
              </li>
              <li>About Us</li>
            </ul>
          </div>
        </div>
      </section>

      {/*About Us */}

      <div className="about-area py-120">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="about-left wow fadeInLeft" data-wow-delay=".25s">
                <div className="about-img">
                  <img src="assets/img/about/01.jpg" />
                </div>
                <div className="about-experience">
                  {/* <div className="about-experience-icon">
                      <i className="icon-plug"></i>
                    </div> */}
                  <b className="text-start">
                    15+ Years Of <br /> Quality Service
                  </b>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div
                className="about-right wow fadeInRight"
                data-wow-delay=".25s"
              >
                <div className="site-heading mb-3">
                  <span className="site-title-tagline">
                    <i className="far fa-lightbulb-on"></i> About Us
                  </span>
                  <h2 className="site-title">
                    Orient <span>Elevators</span>
                  </h2>
                </div>
                <p className="about-text text-justify">
                  Orient Elevators Pvt. Ltd. is one of India’s leading providers
                  of elevator and escalator solutions, dedicated to redefining
                  vertical transportation through innovation, safety, and
                  reliability. With a strong foundation built on engineering
                  excellence and customer trust, Orient Elevators has become a
                  preferred partner for developers, architects, and facility
                  managers across the country.
                </p>
                <p className="about-text text-justify">
                  {" "}
                  Founded with a vision to deliver world-class mobility
                  solutions, the company specializes in the design,
                  manufacturing, installation, modernization, and maintenance of
                  elevators and escalators. From residential complexes and
                  commercial towers to hospitals, hotels, and industrial
                  facilities, Orient Elevators provides customized solutions
                  that meet the diverse needs of modern infrastructure.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/*End About Us */}
    </div>
  );
};

export default AboutUs;
